export const LEAVING_DISCLAIMER = {
    EXIT: "You are now leaving the Havas Lynx Group virtual booth", 
    MAIN_COPY: "The Leave button will open a new browser window", 
    CONTINUE_BUTTON: "Leave", 
    BACK_BUTTON: "Stay"
}